import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import api from 'utils/api';
import { useProviderStore } from 'Store/ProviderStore';

const SummaryMetrics = ({ metrics }) => {
  const [employeeCount, setEmployeeCount] = React.useState('');
  const [serviceCount, setServiceCount] = React.useState('');
  const [todayAppointments, setTodayAppointments] = React.useState('');
  const provider = useProviderStore((state) => state.provider);

  const formatPersianNumber = (num) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return num?.toString()?.replace(/\d/g, (digit) => persianDigits?.[digit]);
  };

  const getNumberofEmployees = async () => {
    try {
      const res = await api.get(`/providers/${provider._id}/employees`);
      const employees = res.data;
      console.log('Number of employees fetched:', employees.length);
      setEmployeeCount(employees.length);
      return employees.length;
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
    // This function should return the number of employees for the given salonId
    // For now, we'll return a placeholder value
  };

  const getNumberOfServices = async () => {
    try {
      const res = await api.get(`/providers/${provider._id}/services`);
      const services = res.data;
      setServiceCount(services.length);
      return services.length;
    } catch (error) {
      console.error('Error fetching services:', error);
      return 0;
    }
  };

  const getNumberOfTodaysAppointments = async () => {
    try {
      const res = await api.get(
        `/providers/${provider._id}/appointments/today`
      );
      const appointments = res.data;
      setTodayAppointments(appointments.length);
      return appointments.length;
    } catch (error) {
      console.error("Error fetching today's appointments:", error);
      return 0;
    }
  };

  useEffect(() => {
    getNumberofEmployees(provider._id);
    getNumberOfServices(provider._id);
  }, [provider._id]);

  const metricCards = [
    {
      title: 'کل خدمات دهنده‌ها',
      value: metrics?.totalSalons,
      icon: 'Store',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+۲',
      changeType: 'increase',
    },
    {
      title: 'کارمندان فعال',
      value: employeeCount,
      icon: 'Users',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+۵',
      changeType: 'increase',
    },
    {
      title: ' سرویس های فعال',
      value: serviceCount,
      icon: 'LayoutGrid',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      change: '+۳',
      changeType: 'increase',
    },
    {
      title: 'نوبت‌های امروز',
      value: metrics?.todayAppointments,
      icon: 'Calendar',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: '+۱۲',
      changeType: 'increase',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-1 transition-all duration-200">
          <div className="flex items-center justify-between mb-4">
            <div
              className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold text-foreground">
                {formatPersianNumber(isNaN(metric?.value) ? 0 : metric?.value)}
              </div>
              <div className="text-sm text-muted-foreground">
                {metric?.title}
              </div>
            </div>
          </div>

          {/* <div className="flex items-center justify-between">
            <div className={`flex items-center gap-1 text-xs ${
              metric?.changeType === 'increase' ? 'text-success' : 'text-error'
            }`}>
              <Icon
                name={metric?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'}
                size={14}
              />
              <span>{metric?.change}</span>
            </div>
            <span className="text-xs text-muted-foreground">از ماه گذشته</span>
          </div> */}
        </div>
      ))}
    </div>
  );
};

export default SummaryMetrics;
